import { authPost } from '../http_client.js';
import type { PlayerDto } from '../dto/player.dto.js';
import type { DailyTaskRewardDto } from '../dto/daily_tasks.dto.js';

export interface ConveyorRecordDto
{
  conveyor_record_seconds: number;
}

export interface ConveyorLevelDto
{
  level: number;
  best_level: number;
  seconds: number;
  retry_price: number;
  rewards: DailyTaskRewardDto[];
}

export interface ConveyorFinishDto extends ConveyorLevelDto
{
  won: boolean;
  granted: DailyTaskRewardDto[];
  next_level: number;
  player: PlayerDto | null;
}

export interface ConveyorRetryDto extends ConveyorLevelDto
{
  player: PlayerDto | null;
}

export function submitConveyorRecord( seconds: number ): Promise<ConveyorRecordDto>
{
  return authPost<ConveyorRecordDto>( 'api/player/me/conveyor/record', { seconds } );
}

export function startConveyorRun(): Promise<ConveyorLevelDto>
{
  return authPost<ConveyorLevelDto>( 'api/player/me/conveyor/start', {} );
}

export function finishConveyorRun( won: boolean, timeout_ms?: number ): Promise<ConveyorFinishDto>
{
  return authPost<ConveyorFinishDto>( 'api/player/me/conveyor/finish', { won }, timeout_ms );
}

export function retryConveyorLevel( timeout_ms?: number ): Promise<ConveyorRetryDto>
{
  return authPost<ConveyorRetryDto>( 'api/player/me/conveyor/retry', {}, timeout_ms );
}
